import axios from "axios";
import { captureMessage } from "logrocket";

/**
 * Helper for LogRocket error reporting with environment checks
 * Falls back to console.log in development or when LogRocket is disabled
 */
export function captureErrorMessage(...props: Parameters<typeof captureMessage>): void {
  const [message, options] = props;
  const isLogRocketEnabled = process.env.REACT_APP_ENABLE_LOG_ROCKET === "true";
  const isDevelopment = process.env.NODE_ENV === "development";

  if (!isLogRocketEnabled || isDevelopment) {
    // Use console.log in development or when LogRocket is disabled
    const tags = options?.tags ? ` | Tags: ${JSON.stringify(options.tags)}` : "";
    console.log(`[LogRocket] ${message}${tags}`);
    return;
  }

  captureMessage(message, options);
}

export const parseError = (error: unknown) => {
  return axios.isAxiosError(error)
    ? `${error.response?.status} ${error.response?.statusText || error.message}`
    : `${error instanceof Error ? error.message : "Unknown error"}`;
};
